// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as DeccoUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CallerDetailsApiModel from "../api-model/CallerDetailsApiModel.bs.js";

function apiModelToState(res) {
  var customer = res.customer;
  return {
          customer: customer !== undefined ? ({
                id: customer.customer_id,
                name: customer.customer_name,
                vendor_name: customer.vendor_name,
                primary_number: customer.primary_number,
                secondary_number: customer.secondary_number
              }) : undefined,
          partners: List.map((function (partner) {
                  return {
                          msisdn: partner.msisdn,
                          uuid: partner.uuid,
                          name: partner.partner_name,
                          primary_number: partner.primary_number,
                          secondary_number: partner.secondary_number,
                          owner_number: partner.owner_number
                        };
                }), res.partners)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(CallerDetailsApiModel.t_decode(json), "CallerDetailsEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
